<div class="page-container">

    <div class="header-section">
        <div class="title-row">
            <button mat-icon-button (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h1>Choose Your Test Type</h1>
        </div>
        <p class="subtitle">Select the category you want to practice and master</p>
    </div>


    <div class="cards-grid">
        <div class="type-card" *ngFor="let type of testTypes" [ngClass]="type.colorClass" (click)="startTest(type)">
            <div class="card-icon-box">
                <mat-icon>{{ type.icon }}</mat-icon>
            </div>

            <h3>{{ type.title }}</h3>
            <p class="description">{{ type.description }}</p>

            <div class="card-footer">


                <div class="start-link">
                    <span>Start</span>
                    <mat-icon>arrow_right_alt</mat-icon>
                </div>
            </div>
        </div>
    </div>


    <div class="quick-tips">
        <div class="tips-header">
            <mat-icon>lightbulb</mat-icon>
            <h3>Quick Tips</h3>
        </div>

        <div class="tips-content">
            <div class="tip-item">
                <span class="tip-number">1.</span>
                <span>Start with <strong>Mixed Test</strong> to identify your weak areas</span>
            </div>
            <div class="tip-item">
                <span class="tip-number">2.</span>
                <span>Use <strong>Company-Specific</strong> tests closer to your interview</span>
            </div>
            <div class="tip-item">
                <span class="tip-number">3.</span>
                <span>Practice daily for best results – consistency beats intensity</span>
            </div>
        </div>
    </div>
</div>